import React from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';
import './tooltip.css.js';

var LTTooltip = function LTTooltip(_a) {
  var className = _a.className,
    children = _a.children,
    customTriggerStyle = _a.customTriggerStyle,
    direction = _a.direction,
    text = _a.text,
    _b = _a.delayDuration,
    delayDuration = _b === void 0 ? 400 : _b;
  if (!text) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(Tooltip.Provider, null, /*#__PURE__*/React.createElement(Tooltip.Root, {
    delayDuration: delayDuration
  }, /*#__PURE__*/React.createElement(Tooltip.Trigger, {
    asChild: true,
    className: "lt-tooltip-trigger",
    style: customTriggerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "tooltipChildrenWrapper"
  }, children)), /*#__PURE__*/React.createElement(Tooltip.Portal, null, /*#__PURE__*/React.createElement(Tooltip.Content, {
    className: "".concat(className, " TooltipContent"),
    side: direction,
    sideOffset: 5
  }, text, /*#__PURE__*/React.createElement(Tooltip.Arrow, {
    className: "TooltipArrow"
  })))));
};
LTTooltip.Direction = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top"
};

export { LTTooltip as default };
